/* Custom JavaScript - Mobile Menu Below Header */

// Make sure the header summary X keeps the drawer open long enough for animations
document.addEventListener('DOMContentLoaded', () => {
  const details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  const headerDrawer = details.closest('header-drawer');
  const summaryToggle = details.querySelector('summary.header__icon--summary');
  if (!headerDrawer || !summaryToggle) return;

  const scheduleAttributeCleanup = () => {
    // Wait for Shopify to remove the menu-open class, then strip the open attribute if it lingers
    if (details.classList.contains('menu-open') || !details.hasAttribute('open')) return;

    setTimeout(() => {
      if (!details.classList.contains('menu-open') && details.hasAttribute('open')) {
        details.removeAttribute('open');
        summaryToggle.setAttribute('aria-expanded', 'false');
      }
    }, 300);
  };

  summaryToggle.addEventListener(
    'click',
    (event) => {
      // If the drawer is already closed we let the default action open it
      if (!details.hasAttribute('open')) return;

      // Prevent the native <summary> toggle from instantly removing the open attribute
      event.preventDefault();

      // Shopify's toggle handler still runs and calls close(), so we just mirror the old close-button fallback
      setTimeout(scheduleAttributeCleanup, 10);
    },
    true
  );
});
